/**
 * Центр уведомлений (BS §13.1).
 */
import type { Notification } from '@shared/api/types'
import { meRepo, notificationsRepo, currentUser, useReplica, useReplicaList } from '@shared/db'

export function useNotifications(): { items: Notification[]; loaded: boolean } {
  // Изменение v1.14: уведомление о входящем звонке живёт, пока звонок звонит, — его показывает
  // экран вызова и push, а в ленте «Движ» после звонка ему нечего делать (итог — в диалоге).
  return useReplicaList(
    async () => (await notificationsRepo.list()).filter((item) => item.type !== 'call'),
    [],
  )
}

/**
 * CC §5.9 п. 2: `unread.notifications` берётся из `Me.unread` и правится
 * на ±1 событиями `notification.created` / `notification.read`;
 * при расхождении побеждает серверное значение.
 */
export function useUnreadNotificationsCount(): number {
  return useReplica(
    async () => {
      const userId = currentUser()
      if (!userId) return 0
      const me = await meRepo.get(userId)
      return me?.unread.notifications ?? 0
    },
    [],
    0,
  )
}
